//1 = light blue, 2 = blue, 3 = yellow, 4 = red

export const orb = [
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 
    0, 0, 0, 3, 0, 5, 5, 0, 0, 3, 0, 0, 
    0, 0, 3, 0, 5, 2, 2, 5, 0, 0, 3, 0, 
    0, 0, 0, 5, 2, 1, 2, 4, 5, 3, 0, 0, 
    0, 0, 5, 2, 4, 2, 1, 2, 2, 5, 0, 0, 
    0, 0, 5, 2, 2, 1, 2, 4, 2, 5, 0, 0, 
    0, 3, 0, 5, 4, 2, 1, 2, 5, 0, 0, 0, 
    0, 0, 0, 3, 5, 2, 2, 5, 3, 0, 0, 0, 
    0, 0, 0, 0, 0, 5, 5, 3, 0, 0, 0, 0, 
    0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
]